
import yaml from "js-yaml";

export function locationToString(location) {
  try {
    return "" + location.lat + ", " + location.lng;
  } catch (error) {
    // console.log("Non valid location object ");
  }
}

export function isValidLocationString(str) {
  if (str === "") return true;
  try {
    let location = stringToLocation(str);
    if (location.lat <= -90 || location.lat >= 90 || isNaN(location.lat))
      return false;
    return !(location.lng <= -180 || location.lng >= 180 || isNaN(location.lng));

  } catch (e) {
    return false;
  }
}

export function stringToLocation(locStr) {
  let locArr = locStr.split(",");
  let lat = locArr[0];
  let lng = trim(locArr[1], ",");
  lng = trim(lng, " ");
  return {
    lat: parseFloat(lat),
    lng: parseFloat(lng),
  };
}

export function trim(s, c) {
  if (c === "]") c = "\\]";
  if (c === "\\") c = "\\\\";
  return s.replace(new RegExp("^[" + c + "]+|[" + c + "]+$", "g"), "");
}

export function reallyNumber(num) {
  return typeof num != "undefined" && num != null && num.isNaN;
}

export function groupBy(xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}


export var exportYAMLData = (function () {
  let a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  return function (data, fileName) {
    let serialized = yaml.dump(data),
        // var json = JSON.stringify(data),
        blob = new Blob([serialized], {type: "octet/stream"}),
        url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName + ".yaml";
    a.click();
    window.URL.revokeObjectURL(url);
  };
})();

Number.prototype.pad = function (size) {
  let s = String(this);
  while (s.length < (size || 2)) {
    s = "0" + s;
  }
  return s;
};

export function exportCSVData(filename, content, withHeader = true, headers) {
  var a = document.createElement("a");
  const headerSet = [...new Set(headers)];

  content = content
      .map(function (d) {
        var arr = [];
        headerSet.forEach((element) => {
          if (d[element.value] === undefined) {
            d[element.value] = "";
          }
          if (d[element.value] === Object(d[element.value])) {
            d[element.value] = JSON.stringify(d[element.value]);
          }
          arr.push(d[element.value]);
        });
        return arr.join(";");
      })
      .join("\n")
      .replace(/(^\[)|(]$)/gm, "");

  var data = "";
  if (withHeader) {
    data = data + headerSet.map((h) => h.text).join(";") + "\n";
  }
  data = data + content;

  var blob = new Blob(["\ufeff", data]);
  a.href = URL.createObjectURL(blob);
  a.download = filename + ".csv";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

// https://sebhastian.com/javascript-csv-to-array/
export function csvToArray(str, withHeader = true, delimiter = ";") {
  if (withHeader) {
    // slice from start of text to the first \n index
    // use split to create an array from string by delimiter
    const headers = str.slice(0, str.indexOf("\n")).split(delimiter);

    // slice from \n index + 1 to the end of the text
    // use split to create an array of each csv value row
    const rows = str.slice(str.indexOf("\n") + 1).split("\n");

    // Map the rows
    // split values from each row into an array
    // use headers.reduce to create an object
    // object properties derived from headers:values
    // the object passed as an element of the array
    return rows.map(function (row) {
      const values = row.split(delimiter);
      return headers.reduce(function (object, header, index) {
        object[header] = values[index];
        return object;
      }, {});
    });
  } else {
    // use split to create an array of each csv value row
    const rows = str.split("\n");

    return rows.map(function (row) {
      return row.split(delimiter);
    });
  }
}

export function sortByKey(a, b, key) {
  var nameA = a[key].toUpperCase();
  var nameB = b[key].toUpperCase();
  if (nameA < nameB) {
    return 1;
  }
  if (nameA > nameB) {
    return -1;
  }
  return 0;
}

export function isDifferent(a, b, keys) {
  var returnValue = false;
  keys.forEach((k) => {
    if (getProperty(a, k) !== getProperty(b, k)) {
      returnValue = true;
    }
  });
  return returnValue;
}

export function delay(time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

export function hasOwnDeepProperty(obj, key) {
  for (let i = 0, path = key.split("."), len = path.length; i < len; i++) {
    console.log(i);
    obj = obj[path[i]];
    if (!obj) return false;
  }
  return true;
}

export function getProperty(o, s) {
  s = s.replace(/\[(\w+)]/g, ".$1"); // convert indexes to properties
  s = s.replace(/^\./, ""); // strip a leading dot
  var a = s.split(".");
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    try {
      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    } catch (error) {
      return undefined;
    }
  }
  return o;
}

export function uniqueId() {
  return Date.now().toString(36) + Math.random().toString(36);
}

export function genHexString(len) {
  const hex = "0123456789ABCDEF";
  let output = "";
  for (let i = 0; i < len; ++i) {
    output += hex.charAt(Math.floor(Math.random() * hex.length));
  }
  return output;
}

export function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
      atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
  );

  return JSON.parse(jsonPayload);
}

export function getRandomColor() {
  var letters = "0123456789ABCDEF";
  var color = "#";
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export function validURL(str) {
  var pattern = new RegExp(
      "^(https?:\\/\\/)" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
      "i"
  ); // fragment locator
  return !!pattern.test(str);
}


// Types
export let integrationTypes = [
  { value: "CHIRPSTACK", text: "Chirpstack (LoRaWAN)" },
  { value: "SWISSCOM", text: "Swisscom (LoRaWAN)" },
  { value: "MQTT", text: "MQTT Client" },
  { value: "REST", text: "REST Client" },
  { value: "WEBHOOK_DIGIMONDO", text: "Webhook (Digimondo)" },
  // MPDT210068-3211: add DIGIMONDO / DIGIMONDO (LoRaWAN)
  { value: "DIGIMONDO", text: "Digimondo (LoRaWAN)" },
  { value: "ELEMENT", text: "Element IoT (LoRaWAN)" },
];

export let serviceTypes = [
  {
    name: "Lighting Service",
    id: "SLS",
    icon: "mdi-lightbulb-on-outline",
  },
  { name: "Valve Service", id: "SVS", icon: "mdi-pipe-valve" },
];

/*export let activationOptions = [
      {
        name:( () => this.$t("_ActivateWithLicence"),
        value: "BY_LICENCE",
      },
      {
        name:( () => this.$t("_ActivateAsAdmin"),
        value: "AS_ADMIN",
      },
      { name:( () => this.$t("_ActivateLater"), value: "NO_ACTIVATION" },
    ]*/

export let alarmTypes = ["WARNING", "ERROR", "INFO"];
